import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Checkbox, FormControlLabel, Switch } from '@material-ui/core';

export enum muteType {
  camera = 'camera',
  mic = 'mic'
}

interface Props {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  intl: { formatMessage: Function };
  isInCall?: boolean;
  isJoinFlowCall?: boolean;
  isMuted?: boolean;
  type: muteType;
}

const messages = defineMessages({
  inputCamera: { id: 'components.avSettings.inputLabel.Camera', defaultMessage: 'Camera' },
  inputMicrophone: { id: 'components.avSettings.inputLabel.Microphone', defaultMessage: 'Microphone' },
  startCameraMuted: { id: 'components.avSettings.startCameraMuted', defaultMessage: 'Start with camera muted' },
  startMicMuted: { id: 'components.avSettings.startMicMuted', defaultMessage: 'Start with microphone muted' }
});

export const DeviceMute = (props: Props) => {
  const { handleChange, intl, isInCall, isJoinFlowCall, isMuted, type } = props;

  if (isInCall || isJoinFlowCall) {
    return (
      <FormControlLabel
        control={<Switch checked={isMuted} onChange={handleChange} name={`${type}Muted`} color="primary" />}
        data-testid={`auto-${type}-mute`}
        label={intl.formatMessage(type === muteType.camera ? messages.inputCamera : messages.inputMicrophone)}
      />
    );
  }

  return (
    <FormControlLabel
      control={<Checkbox checked={isMuted} onChange={handleChange} name={`${type}Muted`} color="primary" />}
      data-testid={`auto-${type}-mute`}
      label={intl.formatMessage(type === muteType.camera ? messages.startCameraMuted : messages.startMicMuted)}
    />
  );
};

export default injectIntl(DeviceMute);
